<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-users"></i> Users</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Email:</label>
                  <div class="control">
                    <span>{{item.email}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12" v-if="item.profile">
                <div class="field">
                  <label class="label">Name:</label>
                  <div class="control">
                    <span>{{item.profile.name}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12" v-if="item.profile && item.profile.school">
                <div class="field">
                    <label class="label">School:</label>
                    <div class="control">
                        <span>{{item.profile.school.name}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Roles:</label>
                  <div class="control" v-for="role in item.roles">
                    <p>{{role.name}}</p>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label @click="toggleSessionsTable" class="label clickable title is-4">Sessions <i v-if="!showSessionsTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showSessionsTable" class="fa has-text-light fa-chevron-up"></i></label>
                    <div v-show="showSessionsTable" class="control" v-if="sessions != null">
                        <sessions-table :page="sessionsPage" @search="onSessionsSearch" @sort="onSessionsOrderBy" @pageChanged="onSessionsPageChanged" :total="sessionsTotal" v-bind:items="sessions" v-bind:actions="false"></sessions-table>
                    </div>
                    <div v-show="showSessionsTable" class="control" v-else>
                        <span>No sessions assigned</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label @click="toggleCatTable" class="label clickable title is-4">Categories <i v-if="!showCatTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showCatTable" class="fa has-text-light fa-chevron-up"></i></label>
                    <div v-show="showCatTable" class="control" v-if="categories != null">
                        <categories-table :pivot="true" :page="catPage" @search="onCatSearch" @sort="onCatOrderBy" @pageChanged="onCatPageChanged" :total="catTotal" v-bind:items="categories" v-bind:actions="false"></categories-table>
                    </div>
                    <div v-show="showCatTable" class="control" v-else>
                        <span>No categories assigned</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label @click="toggleSentencesTable" class="label clickable title is-4">Sentences <i v-if="!showSentencesTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showSentencesTable" class="fa has-text-light fa-chevron-up"></i></label>
                    <div v-show="showSentencesTable" class="control" v-if="sentences != null">
                        <sentences-table :page="sentencesPage" @search="onSentencesSearch" @sort="onSentencesOrderBy" @pageChanged="onSentencesPageChanged" :total="sentencesTotal" v-bind:items="sentences" v-bind:actions="false"></sentences-table>
                    </div>
                    <div v-show="showSentencesTable" class="control" v-else>
                        <span>No sentences assigned</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label @click="toggleCommTable" class="label clickable title is-4">Comments <i v-if="!showCommTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showCommTable" class="fa has-text-light fa-chevron-up"></i></label>
                    <div v-show="showCommTable" class="control" v-if="comments != null">
                        <comments-table :page="commentsPage" @search="onCommSearch" @sort="onCommOrderBy" @pageChanged="onCommPageChanged" :total="commentsTotal" v-bind:items="comments" v-bind:actions="false"></comments-table>
                    </div>
                    <div v-show="showCommTable" class="control" v-else>
                        <span>No comments assigned</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label @click="toggleNewsTable" class="label clickable title is-4">News <i v-if="!showNewsTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showNewsTable" class="fa has-text-light fa-chevron-up"></i></label>
                    <div v-show="showNewsTable" class="control" v-if="news != null">
                        <news-table :page="newsPage" :pivot="true" @search="onNewsSearch" @sort="onNewsOrderBy" @pageChanged="onNewsPageChanged" :total="newsTotal" v-bind:items="news" v-bind:actions="false"></news-table>
                    </div>
                    <div v-show="showNewsTable" class="control" v-else>
                        <span>No news assigned</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label @click="toggleAffiliatesTable" class="label clickable title is-4">Affiliate <i v-if="!showAffiliatesTable" class="fa has-text-light fa-chevron-down"></i> <i v-if="showAffiliatesTable" class="fa has-text-light fa-chevron-up"></i></label>
                <div v-show="showAffiliatesTable" class="columns is-multiline">
                  <div class="column is-4">
                    <div class="box notification is-primary">
                      <div class="heading">Current balance</div>
                      <div class="title">${{affiliateStats.current}}</div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="box notification is-info">
                      <div class="heading">Referred users</div>
                      <div class="title">{{affiliateStats.referrals}}</div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="box notification is-danger">
                      <div class="heading">Total earned</div>
                      <div class="title">${{affiliateStats.earned}}</div>
                    </div>
                  </div>
                </div>
                <div v-show="showAffiliatesTable" class="control" v-if="affiliates != null">
                  <affiliate-table :page="affiliatesPage" :pivot="true" @search="onAffiliatesSearch" @sort="onAffiliatesOrderBy" @pageChanged="onAffiliatesPageChanged" :total="affiliatesTotal" v-bind:items="affiliates" v-bind:actions="false"></affiliate-table>
                </div>
                <div v-show="showAffiliatesTable" class="control" v-else>
                  <span>Nothing to show</span>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <a href="javascript:{}" class="button is-info is-block" @click="resetAffiliateBalance">
                Set balance to paid
              </a>
            </div>
            <div class="column is-2 is-offset-5 is-pulled-right">
                <router-link v-bind:to="{ name: 'user-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>
            </div>
            <div class="column is-2 is-pulled-right">
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import UserRepo from '../../repos/UserRepo';
import AffiliateRepo from '../../repos/AffiliateRepo';
import CategoriesTable from "../categories/Table";
import SentencesTable from "../sentences/Table";
import CommentsTable from "../comments/Table";
import NewsTable from "../news/Table";
import AffiliateTable from "../stats/Table";
import SessionsTable from "../sessions/Table";
import lodash from 'lodash'

export default {
  name: 'users-show',
  components: {CategoriesTable, SentencesTable, CommentsTable, NewsTable, SessionsTable, AffiliateTable},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            affiliateRepo: new AffiliateRepo(this.$auth),
            item: {},
            showSessionsTable: false,
            sessions: [],
            sessionsTotal: 0,
            sessionsQ: '',
            sessionsOrderBy: 'id,asc',
            sessionsPage : 1,
            showCatTable: false,
            categories: [],
            catTotal: 0,
            catQ: '',
            catOrderBy: 'id,asc',
            catPage : 1,
            showSentencesTable: false,
            sentences: [],
            sentencesTotal: 0,
            sentencesQ: '',
            sentencesOrderBy: 'id,asc',
            sentencesPage : 1,
            showCommTable: false,
            comments: [],
            commentsTotal: 0,
            commentsQ: '',
            commentsOrderBy: 'id,asc',
            commentsPage : 1,
            showNewsTable: false,
            news: [],
            newsTotal: 0,
            newsQ: '',
            newsOrderBy: 'id,asc',
            newsPage : 1,
            showAffiliatesTable: false,
            affiliates: [],
            affiliatesTotal: 0,
            affiliatesQ: '',
            affiliatesOrderBy: 'fee,desc',
            affiliatesPage : 1,
            affiliateStats: {
              referrals: 0,
              earned: 0.00,
              current: 0.00
            }
        }
  },
  created(){
    this.getUser(this.$route.params.id);
    this.getSessions();
    this.getCategories();
    this.getSentences();
    this.getComments();
    this.getNews();
    this.getAffiliates();
    this.getAffiliateStats();
  },
  methods: {
    getUser(id){
            this.repo.show(id).then(response => {
                this.item = response.data.data;
            });
        },
    toggleSessionsTable(){
          this.showSessionsTable = !this.showNewsTable;
      },
    onSessionsSearch(q){
          this.sessionsPage = 1;
          this.sessionsQ = q;
          this.getSessions();
      },
    onSessionsOrderBy(orderBy){
          this.sessionsPage = 1;
          this.sessionsOrderBy = orderBy;
          this.getSessions();
      },
    onSessionsPageChanged(page){
          this.sessionsPage = page;
          this.getSessions();
      },
    getSessions(){
          this.repo.sessionsPaginate(this.$route.params.id, this.sessionsPage, this.sessionsQ, this.sessionsOrderBy).then(response => {
              console.log(response.data.data);
              this.sessions = response.data.data;
              this.sessionsTotal = response.data.meta.pagination.total_pages
          });
      },
    toggleCatTable(){
          this.showCatTable = !this.showCatTable;
        },
    onCatSearch(q){
          this.catPage = 1;
          this.catQ = q;
          this.getCategories();
        },
    onCatOrderBy(orderBy){
          this.catPage = 1;
          this.catOrderBy = orderBy;
          this.getCategories();
        },
    onCatPageChanged(page){
          this.catPage = page;
          this.getCategories();
        },
    getCategories(){
          this.repo.categoriesPaginate(this.$route.params.id, this.catPage, this.catQ, this.catOrderBy).then(response => {
              this.categories = response.data.data;
              this.catTotal = response.data.meta.pagination.total_pages
          });
        },
    toggleSentencesTable(){
          this.showSentencesTable = !this.showSentencesTable;
      },
    onSentencesSearch(q){
          this.sentencesPage = 1;
          this.sentencesQ = q;
          this.getSentences();
      },
    onSentencesOrderBy(orderBy){
          this.sentencesPage = 1;
          this.sentencesOrderBy = orderBy;
          this.getSentences();
      },
    onSentencesPageChanged(page){
          this.sentencesPage = page;
          this.getSentences();
      },
    getSentences(){
          this.repo.sentencesPaginate(this.$route.params.id, this.sentencesPage, this.sentencesQ, this.sentencesOrderBy).then(response => {
              this.sentences = response.data.data;
              this.sentencesTotal = response.data.meta.pagination.total_pages
          });
      },
    toggleCommTable(){
          this.showCommTable = !this.showCommTable;
      },
    onCommSearch(q){
          this.commentsPage = 1;
          this.commentsQ = q;
          this.getComments();
      },
    onCommOrderBy(orderBy){
          this.commentsPage = 1;
          this.commentsOrderBy = orderBy;
          this.getComments();
      },
    onCommPageChanged(page){
          this.commentsPage = page;
          this.getComments();
      },
    getComments(){
          this.repo.commentsPaginate(this.$route.params.id, this.commentsPage, this.commentsQ, this.commentsOrderBy).then(response => {
              this.comments = response.data.data;
              this.commentsTotal = response.data.meta.pagination.total_pages
          });
      },
    toggleNewsTable(){
          this.showNewsTable = !this.showNewsTable;
      },
    onNewsSearch(q){
          this.newsPage = 1;
          this.newsQ = q;
          this.getNews();
      },
    onNewsOrderBy(orderBy){
          this.newsPage = 1;
          this.newsOrderBy = orderBy;
          this.getNews();
      },
    onNewsPageChanged(page){
          this.newsPage = page;
          this.getNews();
      },
    getNews(){
          this.repo.newsPaginate(this.$route.params.id, this.newsPage, this.newsQ, this.newsOrderBy).then(response => {
              this.news = response.data.data;
              this.newsTotal = response.data.meta.pagination.total_pages
          });
      },

    toggleAffiliatesTable(){
      this.showAffiliatesTable = !this.showAffiliatesTable;
    },
    onAffiliatesSearch(q){
      this.affiliatesPage = 1;
      this.affiliatesQ = q;
      this.getAffiliates();
    },
    onAffiliatesOrderBy(orderBy){
      this.affiliatesPage = 1;
      this.affiliatesOrderBy = orderBy;
      this.getAffiliates();
    },
    onAffiliatesPageChanged(page){
      this.affiliatesPage = page;
      this.getAffiliates();
    },

    getAffiliates(){
      this.repo.affiliatesPaginate(this.$route.params.id, this.affiliatesPage, this.affiliatesQ, this.affiliatesOrderBy).then(response => {
        this.affiliates = response.data.data;
        this.affiliatesTotal = response.data.meta.pagination.total_pages
      });
    },
    getAffiliateStats(){
      this.affiliateRepo.stats(this.$route.params.id).then(response => {
        this.affiliateStats = response.data.data;
      });
    },
    resetAffiliateBalance(){
          this.affiliateRepo.reset(this.$route.params.id).then(response => {
              this.affiliateStats = response.data.data;
          });
    }
  },
  watch: {

  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/Show.vue